<template>
  <v-app>
    <Alert ref="alert" />
    <Confirm ref="confirm" />

    <SideBar v-if="$store.getters.getAuth" :drawer.sync="drawer" />

    <v-app-bar v-if="$store.getters.getAuth" app dense dark>
      <v-app-bar-nav-icon
        v-if="$store.getters.getAuth"
        @click.prevent="drawer = true"
      />

      <v-toolbar-title>
        <span class="overline">{{ app_name }}</span>
      </v-toolbar-title>

      <v-spacer />

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small @click.prevent="logoutHandle">
            <v-icon small>mdi-logout</v-icon>
          </v-btn>
        </template>
        Cerrar Sesión
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Axios from "axios";

import { APP_NAME, URL_API, getHdrs, getErr } from "@/general";
import {
  startSessionTimeout,
  stopSessionTimeout,
  validateSessionActivity,
} from "@/utils/sessionTimeout";

import SideBar from "@/components/SideBar.vue";
import BtnTheme from "@/components/BtnTheme.vue";

export default {
  components: {
    SideBar,
    BtnTheme,
  },

  data() {
    return {
      app_name: APP_NAME,
      drawer: false,
      session_expiring: false,
    };
  },

  watch: {
    "$store.state.auth": {
      handler(auth) {
        if (auth) {
          this.startIdleControl();
          return;
        }

        stopSessionTimeout();
      },
      immediate: true,
    },
  },

  methods: {
    logout() {
      stopSessionTimeout();

      this.$store.dispatch("logoutAction");

      if (this.$route.name !== "login") {
        this.$router.push({ name: "login" });
      }
    },

    logoutByInactivity() {
      if (this.session_expiring) {
        return;
      }

      this.session_expiring = true;

      const auth = this.$store.getters.getAuth;

      if (!auth || !auth.token) {
        this.logout();
        return;
      }

      Axios.post(`${URL_API}/net/auth/logout`, {}, getHdrs(auth.token)).finally(
        () => {
          this.logout();
          this.session_expiring = false;

          if (this.$root.$alert) {
            this.$root.$alert("warning", "Sesión finalizada por inactividad");
          }
        },
      );
    },

    logoutHandle() {
      this.drawer = false;

      this.$root.$confirm("¿Cerrar sesión?").then((confirmed) => {
        if (!confirmed) {
          return;
        }

        const auth = this.$store.getters.getAuth;

        if (!auth || !auth.token) {
          this.logout();
          return;
        }

        Axios.post(`${URL_API}/net/auth/logout`, {}, getHdrs(auth.token))
          .then(() => {
            this.logout();
          })
          .catch((err) => {
            this.$root.$alert("error", getErr(err));
            this.logout();
          });
      });
    },

    startIdleControl() {
      const expired = validateSessionActivity();

      if (expired) {
        this.logoutByInactivity();
        return;
      }

      startSessionTimeout(() => {
        this.logoutByInactivity();
      });
    },
  },

  mounted() {
    this.$root.$alert = this.$refs.alert.show;
    this.$root.$confirm = this.$refs.confirm.show;

    if (this.$store.getters.getAuth) {
      this.startIdleControl();
    }
  },

  beforeDestroy() {
    stopSessionTimeout();
  },
};
</script>

<style>
.theme--dark.v-application {
  background: #1e1e1e !important;
}

.v-tooltip__content {
  font-size: 12px !important;
}

.v-icon.v-icon {
  vertical-align: baseline !important;
}

.v-alert__icon {
  font-size: 16px !important;
  margin-right: 2px !important;
}

.v-card__title {
  padding: 10px !important;
}

.card_title_margin {
  margin-bottom: 16px !important;
}

.card_title_border {
  margin-bottom: 16px !important;
  border-bottom: 0.5px solid rgba(126, 126, 126, 0.2);
}

.v-color-picker {
  max-width: 100% !important;
}
</style>
